import * as THREE from 'three';

export interface AnimationBinding {
  mixer: THREE.AnimationMixer;
  action: THREE.AnimationAction;
  duration: number;
}

export function bindAnimationClip(
  root: THREE.Object3D,
  clip: THREE.AnimationClip,
): AnimationBinding {
  const mixer = new THREE.AnimationMixer(root);
  const action = mixer.clipAction(clip);

  action.clampWhenFinished = true;
  action.loop = THREE.LoopOnce;
  action.play();

  return {
    mixer,
    action,
    duration: clip.duration,
  };
}

export function applyTimelineTime(
  mixer: THREE.AnimationMixer,
  time: number,
) {
  mixer.setTime(Math.max(0, time));
  mixer.update(0);
}
